import { jsonMember, jsonObject } from 'typedjson';
import { WarehouseLocalizationContextOperationsResponse } from './warehouse-localization-context-operations.response';

@jsonObject
export class WarehouseLocalizationResponse {
  @jsonMember(String)
  public readonly id!: string;

  @jsonMember(Number)
  public readonly position!: number;

  @jsonMember(String)
  public readonly label!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(WarehouseLocalizationContextOperationsResponse)
  public readonly contextOperations!: WarehouseLocalizationContextOperationsResponse;
}
